import { userInfo } from "os";
import { UserRoles } from "./user-roles.enum";

export interface IMiddleware {}
export class Middleware {
    public static buildPermissionMap(): String[] {
        var permissionMap = [];
        permissionMap.push("dashboard");
        if (localStorage.getItem("userRole") === UserRoles.Admin) {
            permissionMap.push(
                "unscopedusers_index",
                "unscopedusers_details",
                "unscopedserviceaccounts_index",
                "unscopedservicekeys_index",
                "serviceproviders_index",
                "serviceproviders_details",
                "contentproviders_index",
                "contentproviders_details",
                "assets_index",
                "assets_details",
                "anumbergroups_index",
                "anumbergroups_details",
                "programcontents_index",
                "programcontents_details",
                "scopedusers_index",
                "scopedusers_details",
                "scopedcontentproviderusers_index",
                "unscopedusers",
                "unscopedusers_details",
                "demos",
                "anumbers_index",
                "massupload_index",
                "anumbers_details",
                "massupload_details",
                "anumbers_indexV2",
                "anumbers_detailsV2",
                "reporting"
            );
            return permissionMap;
        } else if (
            
            localStorage.getItem("userRole") === UserRoles.ServiceProviderAdmin
        ) {
            permissionMap.push(
                "scopedusers_index",
                "scopedusers_details",
                "scopedcontentproviderusers_index",
                "scopedserviceaccounts_index",
                "scopedservicekeys_index",
                "contentproviders_index",
                "contentproviders_details",
                "assets_index",
                "assets_details",
                "anumbers_details",
                "anumbergroups_index",
                "anumbergroups_details",
                "programcontents_index",
                "programcontents_details",
                "demos",
                "anumbers_index",
                "massupload_index",
                "anumbers_details",
                "massupload_details",
                "anumbers_indexV2",
                "anumbers_detailsV2",
                "reporting"
            );
            return permissionMap;
        
        }
        else if (
            
            localStorage.getItem("userRole") === UserRoles.AccountManagerAdmin
        ) {
            permissionMap.push(
                "serviceproviders_index",
                "serviceproviders_details",
                "contentproviders_index",
                "contentproviders_details",
                "assets_index",
                "assets_details",
                "anumbergroups_index",
                "anumbergroups_details",
                "programcontents_index",
                "programcontents_details",
                "scopedusers_index",
                "scopedusers_details",
                "scopedcontentproviderusers_index",
                "demos",
                "anumbers_index",
                "massupload_index",
                "anumbers_details",
                "massupload_details",
                "anumbers_indexV2",
                "anumbers_detailsV2",
                "reporting"
            );
            return permissionMap;
        }
        else if (
            
            localStorage.getItem("userRole") === UserRoles.ContentProviderUser
        ) {
            permissionMap.push(
                "assets_index",
                "assets_details",
                "programcontents_index",
                "programcontents_details",
                "demos",
                "anumbers_index",
                "massupload_index",
                "anumbers_details",
                "massupload_details",
                "anumbers_indexV2",
                "anumbers_detailsV2",
                "anumbers_index",
                "massupload_index",
                "anumbergroups_index",
                "anumbergroups_details",
                "reporting"
            );
            return permissionMap;
        }

        return permissionMap;
    }
}
